<template>
<div class="champion-wrap">
    <h2 class="champion-label">スノーモビル全日本チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('70')"><span class="history__head--circle">1971-1980</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1971年<span class="year-title__sub">昭和46年</span></h2>
                <ul>
                    <li>大月信和／モディファイ300cc</li>
                    <li>青木雅和／モディファイ400cc</li>
                    <li>大月信和／モディファイ401cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1972年<span class="year-title__sub">昭和47年</span></h2>
                <ul>
                    <li>丹治 章／モディファイ300cc</li>
                    <li>丹治 章／モディファイ400cc</li>
                    <li>丹治 章／モディファイ401cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1973年<span class="year-title__sub">昭和48年</span></h2>
                <ul>
                    <li>伊藤盛男／モディファイ340cc</li>
                    <li>小田切信雄／モディファイ440cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1974年<span class="year-title__sub">昭和49年</span></h2>
                <ul>
                    <li>伊藤盛男／モディファイ340cc</li>
                    <li>伊藤盛男／モディファイ440cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1975年<span class="year-title__sub">昭和50年</span></h2>
                <ul>
                    <li>伊藤盛男／モディファイ340cc</li>
                    <li>伊藤盛男／モディファイ440cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1976年<span class="year-title__sub">昭和51年</span></h2>
                <ul>
                    <li>春名 薫／モディファイ340cc</li>
                    <li>春名 薫／モディファイ440cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1977年<span class="year-title__sub">昭和52年</span></h2>
                <ul>
                    <li>藤本整司／モディファイ340cc</li>
                    <li>高橋和雄／モディファイ440cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1978年<span class="year-title__sub">昭和53年</span></h2>
                <ul>
                    <li>丹治 章／モディファイ340cc</li>
                    <li>丹治 章／モディファイ440cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1979年<span class="year-title__sub">昭和54年</span></h2>
                <ul>
                    <li>高橋和雄／モディファイ340cc</li>
                    <li>古川四郎／モディファイ440cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1980年<span class="year-title__sub">昭和55年</span></h2>
                <ul>
                    <li>高橋和雄／モディファイ340cc</li>
                    <li>高橋和雄／モディファイ440cc</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('80')"><span class="history__head--circle">1981-1990</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1981年<span class="year-title__sub">昭和56年</span></h2>
                <ul>
                    <li>南雲静夫／モディファイ300cc</li>
                    <li>佐々木善之／モディファイ340cc</li>
                    <li>本田勝義／モディファイ540cc</li>
                    <li>領毛信治／モディファイオープン</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1982年<span class="year-title__sub">昭和57年</span></h2>
                <ul>
                    <li>古川啓八／モディファイ300cc</li>
                    <li>佐野 博／モディファイ340cc</li>
                    <li>高橋和雄／モディファイ540cc</li>
                    <li>高橋和雄／モディファイオープン</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1983年<span class="year-title__sub">昭和58年</span></h2>
                <ul>
                    <li>佐野 博／モディファイ300cc</li>
                    <li>中山 忠／モディファイ340cc</li>
                    <li>中山 忠／モディファイ540cc</li>
                    <li>藤本正勝／モディファイオープン</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1984年<span class="year-title__sub">昭和59年</span></h2>
                <ul>
                    <li>佐野 博／モディファイ300cc</li>
                    <li>今野 孝／モディファイ340cc</li>
                    <li>藤本正勝／モディファイ540cc</li>
                    <li>高橋和雄／モディファイオープン</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1985年<span class="year-title__sub">昭和60年</span></h2>
                <ul>
                    <li>今野 孝／モディファイ340cc</li>
                    <li>江口享二／モディファイ540cc</li>
                    <li>高橋和雄／モディファイオープン</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1986年<span class="year-title__sub">昭和61年</span></h2>
                <ul>
                    <li>江口亨一／モディファイ340cc</li>
                    <li>熊谷留夫／モディファイ540cc</li>
                    <li>熊谷留夫／モディファイオープン</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1987年<span class="year-title__sub">昭和62年</span></h2>
                <ul>
                    <li>松田勇五郎／モディファイ340cc</li>
                    <li>米田幸一／モディファイ540cc</li>
                    <li>松田勇五郎／モディファイオープン</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1988年<span class="year-title__sub">昭和63年</span></h2>
                <ul>
                    <li>遠藤和也／モディファイ340cc</li>
                    <li>江口亨一／モディファイ540cc</li>
                    <li>遠藤和也／モディファイオープン</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1989年<span class="year-title__sub">昭和64年/平成元年</span></h2>
                <ul>
                    <li>江口亨一／モディファイ340cc</li>
                    <li>遠藤和也／モディファイ540cc</li>
                    <li>遠藤和也／モディファイオープン</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1990年<span class="year-title__sub">平成2年</span></h2>
                <ul>
                    <li>沼倉照義／モディファイB級S1</li>
                    <li>波田野達也／モディファイB級S3</li>
                    <li>梅沢文雄／モディファイB級S4</li>
                    <li>江口享二／モディファイA級S1</li>
                    <li>熊谷留夫／モディファイA級S3</li>
                    <li>江口亨一／モディファイA級S4</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('90')"><span class="history__head--circle">1991-2000</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1991年<span class="year-title__sub">平成3年</span></h2>
                <ul>
                    <li>内野令一／モディファイB級S1</li>
                    <li>梅沢康二／モディファイB級S3</li>
                    <li>木村明訓／モディファイB級S4</li>
                    <li>成田正弘／モディファイA級S1</li>
                    <li>江口亨一／モディファイA級S3</li>
                    <li>大野 勇／モディファイA級S4</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1992年<span class="year-title__sub">平成4年</span></h2>
                <ul>
                    <li>山内康裕／モディファイB級S1</li>
                    <li>又村哲哉／モディファイB級S3</li>
                    <li>八木橋光治／モディファイB級S4</li>
                    <li>成田正弘／モディファイA級S1</li>
                    <li>上葛泰隆／モディファイA級S3</li>
                    <li>高橋晴彦／モディファイA級S4</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1993年<span class="year-title__sub">平成5年</span></h2>
                <ul>
                    <li>千葉賢一／モディファイB級S1</li>
                    <li>千葉賢一／モディファイB級S3</li>
                    <li>泉沢克美／モディファイB級S4</li>
                    <li>上葛泰隆／モディファイA級S1</li>
                    <li>三好一浩／モディファイA級S3</li>
                    <li>高橋晴彦／モディファイA級S4</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1994年<span class="year-title__sub">平成6年</span></h2>
                <ul>
                    <li>関井 誠／モディファイB級S1</li>
                    <li>大和長武／モディファイB級S2</li>
                    <li>郷 和幸／モディファイB級S3</li>
                    <li>戸田幸廣／モディファイB級S4</li>
                    <li>上葛泰隆／モディファイA級S1</li>
                    <li>上葛泰隆／モディファイA級S2</li>
                    <li>中村光彦／モディファイA級S3</li>
                    <li>高橋晴彦／モディファイA級S4</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1995年<span class="year-title__sub">平成7年</span></h2>
                <ul>
                    <li>松田智典／モディファイB級S1</li>
                    <li>柏倉秀伸／モディファイB級S2</li>
                    <li>熊谷聡寛／モディファイB級S3</li>
                    <li>松田智典／モディファイB級S4</li>
                    <li>戸沢真司／モディファイA級S1</li>
                    <li>上葛泰隆／モディファイA級S2</li>
                    <li>三好一浩／モディファイA級S3</li>
                    <li>上野忠夫／モディファイA級S4</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1996年<span class="year-title__sub">平成8年</span></h2>
                <ul>
                    <li>黒沢直也／モディファイB級S1</li>
                    <li>日野義克／モディファイB級S2</li>
                    <li>長内義基／モディファイB級S3</li>
                    <li>日野義克／モディファイB級S4</li>
                    <li>上葛泰隆／モディファイA級S1</li>
                    <li>戸沢真司／モディファイA級S2</li>
                    <li>山下 力／モディファイA級S3</li>
                    <li>上野忠夫／モディファイA級S4</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1997年<span class="year-title__sub">平成9年</span></h2>
                <ul>
                    <li>渋谷博樹／モディファイB級S1</li>
                    <li>渋谷博樹／モディファイB級S2</li>
                    <li>村角修司／モディファイB級S3</li>
                    <li>渋谷博樹／モディファイB級S4</li>
                    <li>郷 敦司／モディファイA級S1</li>
                    <li>戸沢真司／モディファイA級S2</li>
                    <li>山下 力／モディファイA級S3</li>
                    <li>日野義克／モディファイA級S4</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1998年<span class="year-title__sub">平成10年</span></h2>
                <ul>
                    <li>坂上善彦／モディファイB級S1</li>
                    <li>戸沢貴典／モディファイB級S2</li>
                    <li>佐藤哲也／モディファイB級S3</li>
                    <li>桜庭直義／モディファイB級S4</li>
                    <li>戸沢真司／モディファイA級S1</li>
                    <li>中澤裕伺／モディファイA級S2</li>
                    <li>日野義克／モディファイA級S3</li>
                    <li>松田智典／モディファイA級S4</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1999年<span class="year-title__sub">平成11年</span></h2>
                <ul>
                    <li>柴田敏也／モディファイB級S1</li>
                    <li>米内敏也／モディファイB級S2</li>
                    <li>村岡雅人／モディファイB級S3</li>
                    <li>加藤憲一／モディファイB級S4</li>
                    <li>山下 力／モディファイA級スーパークラス</li>
                    <li>川越清貴／モディファイA級S1</li>
                    <li>佐藤 学／モディファイA級S2</li>
                    <li>米沢俊一／モディファイA級S3</li>
                    <li>米沢俊一／モディファイA級S4</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2000年<span class="year-title__sub">平成12年</span></h2>
                <ul>
                    <li>福田純一／モディファイB級S1</li>
                    <li>福田純一／モディファイB級S2</li>
                    <li>伊賀和弘／モディファイB級S3</li>
                    <li>畠山芳廣／モディファイB級S4</li>
                    <li>中澤裕伺／モディファイA級スーパークラス</li>
                    <li>日野義克／モディファイA級S1</li>
                    <li>伊藤栄治／モディファイA級S2</li>
                    <li>寺崎雅史／モディファイA級S3</li>
                    <li>泉沢克美／モディファイA級S4</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('100')"><span class="history__head--circle">2001-2010</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">2001年<span class="year-title__sub">平成13年</span></h2>
                <ul>
                    <li>永倉信明／モディファイB級S1</li>
                    <li>古坂丈二／モディファイB級S2</li>
                    <li>齊藤 将／モディファイB級S3</li>
                    <li>戸沢真司／モディファイA級スーパークラス</li>
                    <li>成田大昌／モディファイA級S1</li>
                    <li>江刺晃人／モディファイA級S2</li>
                    <li>村岡雅人／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2002年<span class="year-title__sub">平成14年</span></h2>
                <ul>
                    <li>蝦名隼人／モディファイB級S1</li>
                    <li>蝦名隼人／モディファイB級S2</li>
                    <li>佐藤誠一郎／モディファイB級S3</li>
                    <li>戸沢真司／モディファイA級スーパークラス</li>
                    <li>吉田善公／モディファイA級S1</li>
                    <li>下村大介／モディファイA級S2</li>
                    <li>寺崎雅史／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2003年<span class="year-title__sub">平成15年</span></h2>
                <ul>
                    <li>高橋利幸／モディファイB級S1</li>
                    <li>芝崎和裕／モディファイB級S2</li>
                    <li>對馬秀光／モディファイB級S3</li>
                    <li>松田智典／モディファイA級スーパークラス</li>
                    <li>稲葉 翔／モディファイA級S1</li>
                    <li>佐藤誠一郎／モディファイA級S2</li>
                    <li>泉 実／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2004年<span class="year-title__sub">平成16年</span></h2>
                <ul>
                    <li>古澤尚児／モディファイB級S1</li>
                    <li>成田裕樹／モディファイB級S2</li>
                    <li>阿久津成一／モディファイB級S3</li>
                    <li>中澤裕伺／モディファイA級スーパークラス</li>
                    <li>熊谷寛樹／モディファイA級S1</li>
                    <li>熊谷寛樹／モディファイA級S2</li>
                    <li>熊谷寛樹／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2005年<span class="year-title__sub">平成17年</span></h2>
                <ul>
                    <li>長谷川周栄／モディファイB級S1</li>
                    <li>高橋良太／モディファイB級S2</li>
                    <li>長谷川周栄／モディファイB級S3</li>
                    <li>中澤裕伺／モディファイA級スーパークラス</li>
                    <li>高村大志／モディファイA級S1</li>
                    <li>笹森健彦／モディファイA級S2</li>
                    <li>阿久津成一／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2006年<span class="year-title__sub">平成18年</span></h2>
                <ul>
                    <li>正野健二／モディファイB級S1</li>
                    <li>池田卓也／モディファイB級S2</li>
                    <li>池田卓也／モディファイB級S3</li>
                    <li>中澤裕伺／モディファイA級スーパークラス</li>
                    <li>熊谷 光／モディファイA級S1</li>
                    <li>熊谷 光／モディファイA級S2</li>
                    <li>荒井良典／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2007年<span class="year-title__sub">平成19年</span></h2>
                <ul>
                    <li>上野 仁／モディファイB級S1</li>
                    <li>村角謙二／モディファイB級S2</li>
                    <li>石毛 航／モディファイB級S3</li>
                    <li>永倉信明／モディファイA級スーパークラス</li>
                    <li>佐野敏之／モディファイA級S1</li>
                    <li>佐々木雅規／モディファイA級S2</li>
                    <li>久保田 雄／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2008年<span class="year-title__sub">平成20年</span></h2>
                <ul>
                    <li>佐藤義暢／モディファイB級S1</li>
                    <li>高村哲太／モディファイB級S2</li>
                    <li>佐藤義暢／モディファイB級S3</li>
                    <li>松田智典／モディファイA級スーパークラス</li>
                    <li>郷 和幸／モディファイA級S1</li>
                    <li>正野健二／モディファイA級S2</li>
                    <li>計良亮太／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2009年<span class="year-title__sub">平成21年</span></h2>
                <ul>
                    <li>栗田晋平／モディファイB級S1</li>
                    <li>山田大樹／モディファイB級S2</li>
                    <li>山田大樹／モディファイB級S3</li>
                    <li>中澤裕伺／モディファイA級スーパークラス</li>
                    <li>上野 仁／モディファイA級S1</li>
                    <li>高村啓太／モディファイA級S2</li>
                    <li>上野 仁／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2010年<span class="year-title__sub">平成22年</span></h2>
                <ul>
                    <li>松田智典／モディファイA級スーパークラス</li>
                    <li>熊谷寛樹／モディファイA級S1</li>
                    <li>村上雅紀／モディファイA級S2</li>
                    <li>熊谷寛樹／モディファイA級S3</li>
                    <li>國分将太郎／モディファイB級S1</li>
                    <li>國分将太郎／モディファイB級S2</li>
                    <li>新屋典孝／モディファイA級S3</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('110')"><span class="history__head--circle">2011-2010</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">2011年<span class="year-title__sub">平成23年</span></h2>
                <ul>
                    <li>駒形和希／モディファイB級S1</li>
                    <li>駒形和希／モディファイB級S2</li>
                    <li>関 博紀／モディファイB級S3</li>
                    <li>佐野友介／モディファイA級スーパークラス</li>
                    <li>國分将太郎／モディファイA級S1</li>
                    <li>國分将太郎／モディファイA級S2</li>
                    <li>石毛 航／モディファイA級S3</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2012年<span class="year-title__sub">平成24年</span></h2>
                <ul>
                    <li>斎藤泰岳／モディファイB級S1</li>
                    <li>斎藤泰岳／モディファイB級S2</li>
                    <li>倉持俊輝／モディファイB級S3</li>
                    <li>佐野友介／モディファイA級スーパークラス</li>
                    <li>林 竜一／モディファイA級S1</li>
                    <li>山内浩二／モディファイA級S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2013年<span class="year-title__sub">平成25年</span></h2>
                <ul>
                    <li>佐藤伶磨／モディファイB級S1</li>
                    <li>山田大至輝／モディファイB級S2</li>
                    <li>大石泰広／モディファイB級S3</li>
                    <li>佐野友介／モディファイA級スーパークラス</li>
                    <li>駒形和希／モディファイA級S1</li>
                    <li>駒形和希／モディファイA級S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2014年<span class="year-title__sub">平成26年</span></h2>
                <ul>
                    <li>信平竜馬／モディファイB級S1</li>
                    <li>信平竜馬／モディファイB級S2</li>
                    <li>笹岡千夏／モディファイB級S3</li>
                    <li>佐々木雅規／モディファイA級スーパークラス</li>
                    <li>佐藤伶磨／モディファイA級S1</li>
                    <li>佐藤伶磨／モディファイA級S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2015年<span class="year-title__sub">平成27年</span></h2>
                <ul>
                    <li>郷 瞬希／モディファイB級S1</li>
                    <li>郷 瞬希／モディファイB級S2</li>
                    <li>倉持晃人／モディファイB級S3</li>
                    <li>松野 元／モディファイA級スーパークラス</li>
                    <li>信平竜馬／モディファイA級S1</li>
                    <li>信平竜馬／モディファイA級S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2016年<span class="year-title__sub">平成28年</span></h2>
                <ul>
                    <li>水口嵩代／モディファイB級S1</li>
                    <li>漆原陸／モディファイB級S2</li>
                    <li>今野淳／モディファイB級S3</li>
                    <li>佐々木雅規／モディファイA級スーパークラス</li>
                    <li>郷 瞬希／モディファイA級S1</li>
                    <li>郷 瞬希／モディファイA級S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2017年<span class="year-title__sub">平成29年</span></h2>
                <ul>
                    <li>竹内寿斗／モディファイB級S1</li>
                    <li>園田弘一／モディファイB級S2</li>
                    <li>佐々木雅規／モディファイA級スーパークラス</li>
                    <li>沼田誠司／モディファイA級S1</li>
                    <li>佐野友介／モディファイA級S2</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2018年<span class="year-title__sub">平成30年</span></h2>
                <ul>
                    <li>佐々木雅規／SX-Pro</li>
                    <li>山田大至輝／SX-A1</li>
                    <li>竹内 啓真／SX-B1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2019年<span class="year-title__sub">平成31年/令和元年</span></h2>
                <ul>
                    <li>佐々木雅規／SX-Pro</li>
                    <li>郷 竜太／SX-A1</li>
                    <li>菊地隆雅／SX-B1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2020年<span class="year-title__sub">令和2年</span></h2>
                <ul>
                    <li>村上 雅紀／SX-Pro</li>
                    <li>沼田 誠司／SX-A1</li>
                    <li>林 侑也／SX-B1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2021年<span class="year-title__sub">令和3年</span></h2>
                <ul>
                    <li>新型コロナウイルス感染症拡大によりシリーズ開催中止</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2022年<span class="year-title__sub">令和4年</span></h2>
                <ul>
                    <li>新型コロナウイルス感染症拡大によりシリーズ開催中止</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['70']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>